import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLocation, Link } from 'react-router-dom';
import { cn } from '../utils/cn';

const { FiMenu, FiShield, FiAlertCircle, FiLogOut } = FiIcons;

export default function Header({ toggleSidebar, tradingMode, setTradingMode, wallet, onSignOut }) {
  const location = useLocation();

  const getPageTitle = () => {
    switch(location.pathname) {
      case '/': return 'Trading Dashboard';
      case '/analytics': return 'Market Analytics';
      case '/trades': return 'Trade History';
      case '/settings': return 'Terminal Settings';
      case '/wallet': return 'Burner Wallet';
      default: return 'SolSnipe';
    }
  };

  return (
    <header className="border-b border-slate-800/50 bg-[#0B0E14]/90 backdrop-blur-md sticky top-0 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-4">
            <button 
              onClick={toggleSidebar} 
              className="lg:hidden p-2 -ml-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-800 transition-colors"
            >
              <SafeIcon icon={FiMenu} className="text-xl" />
            </button>
            <h2 className="text-lg font-semibold text-slate-200 hidden sm:block">
              {getPageTitle()}
            </h2>
          </div>

          <div className="flex items-center gap-3 md:gap-4">
            {/* Trading Mode Toggle */}
            <div className="flex items-center gap-1 bg-slate-900 p-1 rounded-lg border border-slate-800">
              <button 
                onClick={() => setTradingMode('PAPER')} 
                className={cn(
                  "px-3 py-1.5 text-[10px] font-bold rounded transition-colors tracking-widest",
                  tradingMode === 'PAPER' ? "bg-slate-700 text-white shadow-sm" : "text-slate-500 hover:text-slate-300"
                )}
              >
                PAPER
              </button>
              <button 
                onClick={() => setTradingMode('LIVE')} 
                className={cn(
                  "px-3 py-1.5 text-[10px] font-bold rounded transition-colors flex items-center gap-1.5 tracking-widest",
                  tradingMode === 'LIVE' ? "bg-red-500/10 text-red-400 shadow-sm border border-red-500/20" : "text-slate-500 hover:text-slate-300"
                )}
              >
                <span className={cn("w-1.5 h-1.5 rounded-full", tradingMode === 'LIVE' ? "bg-red-500 animate-pulse" : "bg-transparent")}></span>
                LIVE
              </button>
            </div>

            <div className="h-6 w-px bg-slate-800 mx-1 hidden sm:block"></div>

            {/* Burner Wallet Navigation/Status Link */}
            <Link
              to="/wallet"
              className="flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-200 px-3 py-2 rounded-lg text-sm font-medium transition-colors border border-slate-700"
            >
              <SafeIcon icon={wallet ? FiShield : FiAlertCircle} className={wallet ? 'text-purple-400' : 'text-yellow-500'} />
              <span className="hidden sm:inline">
                {wallet?.pubkey ? `${wallet.pubkey.substring(0, 4)}...${wallet.pubkey.slice(-4)}` : 'Setup Burner'}
              </span>
            </Link>

            {onSignOut && (
              <button
                onClick={onSignOut}
                title="Sign out"
                className="p-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-800 transition-colors border border-slate-700"
              >
                <SafeIcon icon={FiLogOut} />
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}